import React from 'react';

interface UploadImageIconProps {
  size?: number;
  color?: string;
}

/**
 * UploadImageIcon Component
 * @description An icon for uploading images
 */
export const UploadImageIcon: React.FC<UploadImageIconProps> = ({ 
  size = 16, 
  color = '#fff' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 16 16"
    >
      <path 
        stroke={color} 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        strokeWidth="1.5" 
        d="M8 13.333h6m-12 0h1.116c.326 0 .49 0 .643-.037q.205-.048.385-.16c.135-.082.25-.197.48-.427L13 4.333a1.414 1.414 0 1 0-2-2L2.625 10.71c-.23.23-.346.345-.429.48q-.11.181-.16.385C2 11.728 2 11.891 2 12.217z"
      />
    </svg>
  );
};

export default UploadImageIcon;
